import { composedFetch } from './helpers'
import { getCurrentUserIdToken } from '@/services/auth'

import { getConnectorRootURL } from '@/config'
import { errorIfInvalidResponse } from './errors'

const PROFILE_ENDPOINT_URL = getConnectorRootURL() + '/users/self'
const CANCEL_SUBSCRIPTION_ENDPOINT_URL = PROFILE_ENDPOINT_URL + '/cancel_subscription'
const UNCANCEL_SUBSCRIPTION_ENDPOINT_URL = PROFILE_ENDPOINT_URL + '/uncancel_subscription'

type ProfileUpdateFields = {
  first_name?: string
  last_name?: string
  workstation_turn_off_on_disconnect?: boolean
  block_stoppage_access?: boolean
}
export const apiUpdateProfile = async (changes: ProfileUpdateFields) => {
  const response = await composedFetch(
    'PATCH',
    PROFILE_ENDPOINT_URL,
    await getCurrentUserIdToken(),
    changes,
  )
  await errorIfInvalidResponse(response)
  return await response.json()
}

/**
 * Gets the freshest Profile data.
 * @returns Profile Data (also called UserOut)
 */
export const apiGetProfile = async (): Promise<any> => {
  const response = await composedFetch('GET', PROFILE_ENDPOINT_URL, await getCurrentUserIdToken())
  await errorIfInvalidResponse(response)
  return await response.json()
}

/**
 * Cancel subscription
 * @param reason: a user-given strinng describing reasons for cancelation and suggestions
 * @returns API response, validated for 2xx status
 */
export const apiCancelSubscription = async (reason: string): Promise<any> => {
  const response = await composedFetch(
    'PATCH',
    CANCEL_SUBSCRIPTION_ENDPOINT_URL,
    await getCurrentUserIdToken(),
    { reason },
  )

  await errorIfInvalidResponse(response)
  return await response.json()
}

/**
 * Continue Canceled Subscription
 * @returns json, it's not really used tho
 */
export const apiContinueCanceledSubscription = async (): Promise<any> => {
  const response = await composedFetch(
    'PATCH',
    UNCANCEL_SUBSCRIPTION_ENDPOINT_URL,
    await getCurrentUserIdToken(),
  )

  await errorIfInvalidResponse(response)
  return await response.json()
}
